<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13UvhCy/image/cover.jpg?1706297465157" alt="This image is the cover for the book Escape Manual for Introverts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Escape Manual for Introverts
      </h1>
      <p class="bookDescription body article font2">
        <p>Trapped in an airplane seated next to a chatterbox? Are you hosting a dinner party with people who just won't leave? Katie Vaz has the key to your escape. <i>The Escape Manual for Introverts</i> guides readers through different scenarios with themed chapters ("Friends," "Relatives," "Strangers," etc.). Each chapter covers a range of situations, from an invitation to karaoke night to group lunchtime. And she offers a number of escapes for each scenario: bringing odoriferous foods to lunch for a while, having a pet (real or imagined) that "requires" frequent check-ins, and even investing in a jet pack. This book features Vaz's full-page illustrated spreads, hand-lettering, and spot illustrations. From the silly to the sincere, Vaz's clever, hilarious escape plans and bizarre excuses speak to the introvert in all of us. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Vaz
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df81da06